import { render, staticRenderFns } from "./CarouselImageNew.vue?vue&type=template&id=24e54790&scoped=true&"
import script from "./CarouselImageNew.vue?vue&type=script&lang=js&"
export * from "./CarouselImageNew.vue?vue&type=script&lang=js&"
import style0 from "./CarouselImageNew.vue?vue&type=style&index=0&id=24e54790&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e54790",
  null
  
)

export default component.exports